import React from 'react';
import { CustomTableHeadersProps } from "@dev/ee-components";
import { useTranslation } from "react-i18next";

export const useTableHeaders = (): CustomTableHeadersProps[] => {
    const { t } = useTranslation();

    return [
        {
            id: 'preview',
            numeric: false,
            label: '',
        },
        {
            id: 'campaignsName',
            numeric: false,
            label: t('name'),
        },
        {
            id: 'opened',
            numeric: true,
            label: <span style={{ paddingRight: '10px' }}>{t('opened')}</span>,
            headerAlign: 'right',
            columnAlign: 'right',
        },
        {
            id: 'clicked',
            numeric: true,
            label: <span style={{ paddingRight: '10px' }}>{t('clicked')}</span>,
            headerAlign: 'right',
            columnAlign: 'right',
        },
        {
            id: 'status',
            numeric: false,
            label: '',
        },
        {
            id: 'dropdown',
            numeric: false,
            label: '',
        },
    ];
};
